export const initialState = {
  filters: {},
  users: []
};
